import { memo, Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import { RouteEnum } from '@appTypes/enums/global'

import { Header } from '@components'
import Content from '@components/Hocs/Content'
import { ContentLoader } from '@layout/Private/styled'

function LayoutPublic() {
  return (
    <>
      <Header type={RouteEnum.PUBLIC} />
      <Content type={RouteEnum.PUBLIC}>
        <Suspense fallback={<ContentLoader />}>
          <Outlet />
        </Suspense>
      </Content>
    </>
  )
}

export default memo(LayoutPublic)
